import axios from '@/api';

export function getCompetitionCycle(competitionId) {
    return axios.get(`panel/competitions/${competitionId}/cycle`);
}

export function updateCompetitionCycle(competitionId, payload) {
    return axios.put(`panel/competitions/${competitionId}/cycle`, payload);
}
